/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Nav_OnlineInputs */

const en_cad_nav_online = /** @type {(inputs: Cad_Nav_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Online`)
};

/**
* | output |
* | --- |
* | "Use Online" |
*
* @param {Cad_Nav_OnlineInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_nav_online = /** @type {((inputs?: Cad_Nav_OnlineInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Nav_OnlineInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_nav_online(inputs)
});
export { cad_nav_online as "cad.nav.online" }